// @flow

import React from "react";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const People = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 12 12">
            <g>
                <circle cx="6" cy="3.14" r="2.78" />
                <path d="M11,9.57V9A2.77,2.77,0,0,0,8.22,6.24H3.78A2.77,2.77,0,0,0,1,9v.56s1.07,2.07,4.93,2.07S11,9.58,11,9.57Z" />
            </g>
        </svg>
    </SvgIcon>
);

export default People;
